import Util from '@/lib/util'
export default [
    {
        title:Util.L('Client'),
        key:'clientName'
    }]
